// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"52":"983085ea","161":"4dc4b3b0","543":"d03eb962","706":"983085ea"}[chunkId] + ".chunk.css";
};